import { Order, Product } from "../../types/interfaces";

export const updateFlow = async (
  updateOrder: (data: {
    variables: {
      data: any;
      where: { id: string };
    };
  }) => Promise<Order>,
  mappedValues: FlowMappedValues,
  orderId: string,
  product: Product
) => {
  try {
    return await updateOrder({
      variables: {
        data: {
          products: {
            update: {
              data: {
                removableItem: {
                  updateMany: {
                    data: {
                      workflowType: {
                        set: mappedValues.workflow,
                      },
                    },
                    where: {
                      id: {
                        in: product.removableItem.map(item => item.id) ?? [],
                      },
                    },
                  },
                },
              },
              where: {
                id: product.id,
              },
            },
          },
        },
        where: {
          id: orderId,
        },
      },
    });
  } catch (error) {
    console.error("Failed to update flow:", error);
    throw error;
  }
};

export type FlowMappedValues = Record<string, unknown> & {
  workflow: string;
};
